import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { RolesListItem } from '@/types/settings-api';

/**
 * Roles list for the Roles tab (PROD-759).
 *
 * `GET /api/TenantRoles/Get/{organizationId}`
 *
 * Flutter source: `settings_data_source_impl.dart:951-960`. The Identity API
 * `/api/TenantRoles` controller — same prefix the Edit dialog uses (Get role
 * by ID, Archive, Activate). **Returns ALL roles** (active + archived) in a
 * single response; archive filtering is client-side via `isArchived` on each
 * row. No `showArchived` query parameter.
 *
 * Original implementation used `/api/Role/RoleList?organizationId&showArchived`
 * which is a REST guess — not an endpoint that exists on the .NET backend.
 * Fixed 2026-05-12 after a 404 was reported.
 */
export function useRolesList(organizationId: string | null | undefined) {
  return useQuery({
    queryKey: ['settings', 'roles-list', organizationId],
    queryFn: ({ signal }) => {
      if (!organizationId) throw new Error('useRolesList called without orgId');
      return get<RolesListItem[]>(`/api/TenantRoles/Get/${organizationId}`, { signal });
    },
    enabled: !!organizationId,
  });
}
